import { ref } from 'vue';

const show = ref(false);
const loginType = ref<'sign-up' | 'sign-in'>('sign-up');
const onAuthSuccess = ref<(() => void) | null>(null);

export function useAuthModal() {
  const openAuthModal = (
    type: 'sign-up' | 'sign-in' = 'sign-up',
    callback: (() => void) | null = null
  ) => {
    loginType.value = type;
    show.value = true;
    onAuthSuccess.value = callback;
  };

  const closeAuthModal = () => {
    show.value = false;
    onAuthSuccess.value = null;
  };

  const handleAuthSuccess = () => {
    show.value = false;
    if (onAuthSuccess.value) {
      onAuthSuccess.value();
      onAuthSuccess.value = null;
    }
  };

  return {
    show,
    loginType,
    openAuthModal,
    closeAuthModal,
    handleAuthSuccess,
  };
}
